/**
 * GameState.ts — the top-level screens/phases the game moves between.
 * Transitions get wired up as the menus and race loop arrive in later
 * milestones; for now this just names the states.
 */
export enum GameState {
  Boot = 'Boot',
  Menu = 'Menu',
  CitySelect = 'CitySelect',
  Globe = 'Globe',
  Countdown = 'Countdown',
  Racing = 'Racing',
  Finished = 'Finished',
  Paused = 'Paused',
}
